/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NovitusPaymentCouponDto
 */
export interface NovitusPaymentCouponDto {
    /**
     * Nazwa formy płatności kuponem
     * @type {string}
     * @memberof NovitusPaymentCouponDto
     */
    name: string;
    /**
     * Wartość płatności kuponem
     * @type {string}
     * @memberof NovitusPaymentCouponDto
     */
    value: string;
}

/**
 * Check if a given object implements the NovitusPaymentCouponDto interface.
 */
export function instanceOfNovitusPaymentCouponDto(value: object): value is NovitusPaymentCouponDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function NovitusPaymentCouponDtoFromJSON(json: any): NovitusPaymentCouponDto {
    return NovitusPaymentCouponDtoFromJSONTyped(json, false);
}

export function NovitusPaymentCouponDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): NovitusPaymentCouponDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'value': json['value'],
    };
}

export function NovitusPaymentCouponDtoToJSON(value?: NovitusPaymentCouponDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'value': value['value'],
    };
}

